import { render, staticRenderFns } from "./file-preview.vue?vue&type=template&id=209dd69b&scoped=true"
import script from "./file-preview.vue?vue&type=script&lang=js"
export * from "./file-preview.vue?vue&type=script&lang=js"
import style0 from "./file-preview.vue?vue&type=style&index=0&id=209dd69b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209dd69b",
  null
  
)

export default component.exports